var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1748 28.9501L13.6498 135C12.3401 137.268 11.647 139.84 11.6397 142.459C11.6324 145.078 12.311 147.654 13.608 149.929C14.905 152.204 16.7752 154.101 19.0326 155.429C21.29 156.757 23.8558 157.471 26.4748 157.5H153.525C156.144 157.471 158.71 156.757 160.967 155.429C163.224 154.101 165.095 152.204 166.392 149.929C167.689 147.654 168.367 145.078 168.36 142.459C168.353 139.84 167.66 137.268 166.35 135L102.825 28.9501C101.488 26.7459 99.6052 24.9235 97.3588 23.6587C95.1123 22.3939 92.5778 21.7295 89.9998 21.7295C87.4218 21.7295 84.8873 22.3939 82.6408 23.6587C80.3944 24.9235 78.5118 26.7459 77.1748 28.9501Z",
    fill: "#FCF2DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9998 67.5001V97.5001M89.9998 127.5H90.0748M77.1748 28.9501L13.6498 135C12.3401 137.268 11.647 139.84 11.6397 142.459C11.6324 145.078 12.311 147.654 13.608 149.929C14.905 152.204 16.7752 154.101 19.0326 155.429C21.29 156.757 23.8558 157.471 26.4748 157.5H153.525C156.144 157.471 158.71 156.757 160.967 155.429C163.224 154.101 165.095 152.204 166.392 149.929C167.689 147.654 168.367 145.078 168.36 142.459C168.353 139.84 167.66 137.268 166.35 135L102.825 28.9501C101.488 26.7459 99.6052 24.9235 97.3588 23.6587C95.1123 22.3939 92.5778 21.7295 89.9998 21.7295C87.4218 21.7295 84.8873 22.3939 82.6408 23.6587C80.3944 24.9235 78.5118 26.7459 77.1748 28.9501Z",
    stroke: "#E8B931",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewClient);
export default __webpack_public_path__ + "static/media/review_client.56c628e8c3db118a9d83f93474b54c58.svg";
export { ForwardRef as ReactComponent };